export function isProduction(): boolean {
  return __APP_VERCEL_ENV__ === "production"
}
